var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("div", { ref: "top", attrs: { id: "top" } }),
      _c("searchhead-checkbox", {
        attrs: {
          searchType: "2",
          hideSome: true,
          searchTitle: "新注册企业查询",
          isNewCompany: true,
        },
        on: {
          resetUnlockQ: _vm.resetUnlockQ,
          "set-condition": _vm.setCondition,
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.lock",
              value: _vm.waiting,
              expression: "waiting",
              modifiers: { lock: true },
            },
          ],
        },
        [
          _c(
            "company-card-list",
            {
              ref: "cardlist",
              staticClass: "ccl",
              staticStyle: { "padding-bottom": "0" },
              attrs: {
                resetUnlockS: _vm.isUnlock,
                companyType: 2,
                batchActions: _vm.batchActions,
                list: _vm.list,
              },
              on: {
                "isUnlock-Change": _vm.isUnlockChange,
                "handle-page-num": _vm.handlePageNum,
                "handle-page": _vm.handlePage,
                getData: _vm.getData,
              },
              scopedSlots: _vm._u([
                {
                  key: "beforeBatch",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "interestExpire",
                              rawName: "v-interestExpire",
                            },
                          ],
                          staticClass: "gbBatchBtn",
                          attrs: {
                            loading: _vm.actionLoading,
                            type: "info",
                            plain: "",
                            size: "small",
                          },
                          on: { click: _vm.batchUnlockFnbefore },
                        },
                        [_vm._v("解锁前500")]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "two",
                  fn: function () {
                    return [
                      _c("intel-sort", {
                        attrs: { value: _vm.sortValue },
                        on: { sortChange: _vm.sortChange },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("div", { staticClass: "font-15-md" }, [
                _vm._v(" " + _vm._s(_vm.listTip)),
                _c(
                  "span",
                  {
                    staticClass: "blueColor",
                    staticStyle: { color: "#5088FF" },
                  },
                  [_vm._v(" " + _vm._s(_vm._totalElements) + " ")]
                ),
                _vm._v("家企业 "),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("robot"),
      _c("right-float", {
        ref: "rightFloat",
        attrs: { globalRfType: false },
        on: { scrollToView: _vm.scrollToView },
      }),
      _c("div", { ref: "bottom", attrs: { id: "bottom" } }),
      _c("unlock-dialog-batch", {
        attrs: {
          show: _vm.unlockDialogShowBatch,
          maxTotal: _vm.list.total,
          list: _vm.companyList,
          title: "批量解锁",
          confirmPromise: _vm.contactsNumBatchConfirmBatch,
        },
        on: {
          "update:show": function ($event) {
            _vm.unlockDialogShowBatch = $event
          },
        },
      }),
      _c("batch-unlock-tip", { ref: "batchUnlockTip" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }